import {
  APIfetchAcceptedTermsOfService,
  APIgetUploadPage,
  APIauthUploadPage,
} from '../api/UploadPages';

export const SET_UPLOAD_PAGE = 'SET_UPLOAD_PAGE';
export const SET_UPLOAD_PAGE_LOADING = 'SET_UPLOAD_PAGE_LOADING';
export const SET_UPLOAD_PAGE_NOT_FOUND = 'SET_UPLOAD_PAGE_NOT_FOUND';
export const SET_UPLOAD_PAGE_LOCKED = 'SET_UPLOAD_PAGE_LOCKED';
export const SET_UPLOAD_PAGE_DRAG_DROP_ENABLED = 'SET_UPLOAD_PAGE_DRAG_DROP_ENABLED';
export const SET_UPLOAD_PAGE_ERROR = 'SET_UPLOAD_PAGE_ERROR';
export const SET_UPLOAD_PAGE_BATCH_ID = 'SET_UPLOAD_PAGE_BATCH_ID';

export const setUploadPage = uploadPage => ({
  type: SET_UPLOAD_PAGE,
  uploadPage,
});

export const setUploadPageLoading = loading => ({
  type: SET_UPLOAD_PAGE_LOADING,
  loading,
});

export const setUploadPageNotFound = notFound => ({
  type: SET_UPLOAD_PAGE_NOT_FOUND,
  notFound,
});

export const setUploadPageLocked = locked => ({
  type: SET_UPLOAD_PAGE_LOCKED,
  locked,
});

export const setUploadPageDragDropEnabled = dragDropEnabled => ({
  type: SET_UPLOAD_PAGE_DRAG_DROP_ENABLED,
  dragDropEnabled,
});

export const setUploadPageError = error => ({
  type: SET_UPLOAD_PAGE_ERROR,
  error,
});

export const setUploadBatchId = () => ({
  type: SET_UPLOAD_PAGE_BATCH_ID,
});

export const fetchUploadPage = (uploadPageUuid) => (dispatch) => {
  dispatch(setUploadPageLoading(true));
  dispatch(setUploadPage(null));
  dispatch(setUploadPageError(null));
  return APIgetUploadPage(uploadPageUuid)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(setUploadPage(data));
        if (
          data.require_password ||
          data.require_email ||
          data.require_name
        ) {
          dispatch(setUploadPageLocked(true));
        }
        return data;
      }
      return response;
    }).catch((error) => {
      if (error.response?.status === 404) {
        dispatch(setUploadPageNotFound(true));
      } else {
        dispatch(setUploadPageError(error.response.error));
      }
      return error.response;
    }).finally(() => {
      dispatch(setUploadPageLoading(false));
    });
};

export const authUploadPage = (uploadPageUuid, params) => (dispatch) => (
  APIauthUploadPage(uploadPageUuid, params)
    .then((response) => {
      dispatch(setUploadPageLocked(false));
      return response;
    })
    .catch((error) => (error.response))
);

export const fetchAcceptedTermsOfService = (uploadPageUuid, page, perPage) => (
  APIfetchAcceptedTermsOfService(uploadPageUuid, { page, per_page: perPage })
    .then(response => response.data)
    .catch(error => (error))
);
